<script setup lang="ts">
import { Attachment } from '../../store/useMessages'
import { Capacitor } from '@capacitor/core'
import { MessagesModel } from '../../models/MessagesModel'
import { onBeforeMount, ref } from 'vue'
import { useNetwork } from '../../composables/useNetwork'
/**
 * This component renders attachment link. In browser it is simply a link to the
 * resource. In native mode, it checks for the attachment in the system. If not there,
 * it will download it.
 */

const props = defineProps<{
  attachment: Attachment
}>()
const isNative = Capacitor.isNativePlatform()
const onDevice = ref(false)
//wrapper
const checkOnDevice = async () => {
  return await MessagesModel().attachmentOnDevice(props.attachment)
}
const openNative = async () => {
  if (!getStatus.value) {
    return
  }
  console.log('open native')
  //download and open
  if (!onDevice.value) {
    await download()
  }
  //check one more time, value may have changed after download
  if (onDevice.value) {
    console.log('open attachment')
    await MessagesModel().openAttachment(props.attachment)
  }
}
const { getStatus } = useNetwork()
const isDownloading = ref(false)
const download = async () => {
  isDownloading.value = true
  await MessagesModel().downloadAttachment({
    id: props.attachment.id,
    name: props.attachment.name,
    url: props.attachment.link,
  })
  isDownloading.value = false
  onDevice.value = await checkOnDevice()
}

onBeforeMount(async () => {
  onDevice.value = await checkOnDevice()
})
</script>
<template>
  <div class="row">
    <span v-if="isNative && getStatus" class="text-primary underline row" @click="openNative">
      <q-icon name="attachment" size="sm" color="grey-7" class="q-mr-xs" />
      <template v-if="!onDevice">Download</template>
      {{ attachment.name }}
    </span>
    <span
      v-else-if="isNative && !getStatus"
      :class="onDevice ? 'text-primary underline row' : 'text-black row'"
      @click="openNative"
    >
      <q-icon name="attachment" size="sm" color="grey-7" class="q-mr-xs" />
      {{ attachment.name }}
    </span>

    <a
      v-else
      class="text-primary underline"
      :href="attachment.link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <q-icon name="attachment" size="sm" color="grey-7" class="q-mr-xs" />
      {{ attachment.name }}
    </a>
    <q-spinner v-if="isDownloading" color="primary" size="sm" />
  </div>
</template>
